import { BarChart } from '../../../renderers/bar-chart/bar-chart.component';
import { ChartRendererProps } from '../../../types/chart-renderer-props';
import { VENDING_PACKAGE_VOLUME_HOUR_BAR_CHART_DEFINITION } from './vending-package-volume-hour-bar-chart.definition';
import { VENDING_PACKAGE_VOLUME_HOUR_BAR_CHART_MOCK_DATA } from './vending-package-volume-hour-bar-chart.mock';

export const VendingPackageVolumeHourBarChart = (props: ChartRendererProps) => <BarChart {...props} />;

VendingPackageVolumeHourBarChart.definition = VENDING_PACKAGE_VOLUME_HOUR_BAR_CHART_DEFINITION;
VendingPackageVolumeHourBarChart.mockData = VENDING_PACKAGE_VOLUME_HOUR_BAR_CHART_MOCK_DATA;
